import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Result } from '../Api';

const isDev = process.env.NODE_ENV !== 'production';

export interface AxiosError extends Error {
  config: AxiosRequestConfig;
  code?: string;
  request?: any;
  response?: AxiosResponse<Result<any>>;
}

export default axios;
export * from 'axios';

export function throwIfServerError(error: AxiosError) {
  let errMsg = 'Unexpected_error_occurred';
  if (error && error.response && error.response.data) {
    if (error.response.data.UserMessage) {
      errMsg = error.response.data.UserMessage;
    }
    // try to recover w developer message
    if (
      !error.response.data.UserMessage &&
      error.response.data.DeveloperMessage
    ) {
      errMsg = error.response.data.DeveloperMessage;
    }
    if (isDev && error.response.data.DeveloperMessage !== errMsg) {
      errMsg = `${errMsg} (${error.response.data.DeveloperMessage})`;
    }
  }

  throw new Error(errMsg);
}
